import { render, staticRenderFns } from "./settingMain.vue?vue&type=template&id=7ace7b9e"
import script from "./settingMain.vue?vue&type=script&lang=js"
export * from "./settingMain.vue?vue&type=script&lang=js"
import style0 from "./settingMain.vue?vue&type=style&index=0&id=7ace7b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports